import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess22002Status: 'idle',
    startProcess22002Error: undefined as any,
    loadUserParamsProcess22002Status: 'idle',
    loadUserParamsProcess22002Error: undefined as any,

    process22002List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess22002 = createAsyncThunk('process22002Slice/startProcess22002', async ({ process22002 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess22002/`,
        prepareData(process22002),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess22002Status } = getState().process22002Slice
        return startProcess22002Status !== 'pending'
    }
})

export const loadUserParamsProcess22002 = createAsyncThunk('process22002Slice/loadUserParamsProcess22002', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess22002/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess22002Status } = getState().process22002Slice
        return loadUserParamsProcess22002Status !== 'pending'
    }
})

const Process22002Slice = createSlice({
    name: 'process22002Slice',
    initialState,
    reducers: {
        resetstartProcess22002: (state) => {
            state.job = undefined
            state.startProcess22002Error = undefined
        },
        resetstartProcess22002Error: (state) => {
            state.startProcess22002Error = undefined
        },
        resetloadUserParamsProcess22002: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess22002Error = undefined
        },
        resetloadUserParamsProcess22002Error: (state) => {
            state.loadUserParamsProcess22002Error = undefined
        },
        removeFromProcess22002ListById: (state, action) => {
            state.process22002List = state.process22002List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess22002ListByIds: (state, action) => {
            state.process22002List = state.process22002List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process22002List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess22002Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process22002List = []
            state.startProcess22002Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess22002.pending, (state) => {
            state.startProcess22002Status = 'pending'
            state.startProcess22002Error = undefined
        })
        builder.addCase(startProcess22002.fulfilled, (state, action) => {
            state.startProcess22002Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess22002.rejected, (state, action) => {
            state.startProcess22002Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess22002Error = action.error.message
            } else {
                state.startProcess22002Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess22002.pending, (state) => {
            state.loadUserParamsProcess22002Status = 'pending'
            state.loadUserParamsProcess22002Error = undefined
        })
        builder.addCase(loadUserParamsProcess22002.fulfilled, (state, action) => {
            state.loadUserParamsProcess22002Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess22002.rejected, (state, action) => {
            state.loadUserParamsProcess22002Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess22002Error = action.error.message
            } else {
                state.loadUserParamsProcess22002Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess22002,
    resetstartProcess22002Error,
    resetloadUserParamsProcess22002,
    resetloadUserParamsProcess22002Error,
    removeFromProcess22002ListById,
    removeFromProcess22002ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process22002Slice.actions
export default Process22002Slice.reducer
